import http from '@/utils/http';

/**
 * 客户进件
 */
export default {
  getList: {
    p: 'post,/manage/guestinto/getlist',
    r: (data) => http({ url: '/manage/guestinto/getlist', method: 'post', data })
  },
  add: {
    p: 'post,/manage/guestinto/add',
    r: (data) => http({ url: '/manage/guestinto/add', method: 'post', data })
  },
  update: {
    p: 'post,/manage/guestinto/update',
    r: (data) => http({ url: '/manage/guestinto/update', method: 'post', data })
  },
  del: {
    p: 'post,/manage/guestinto/delete',
    r: (data) => http({ url: '/manage/guestinto/delete', method: 'post', data })
  },
  getOne: {
    p: 'post,/manage/guestinto/getone',
    r: (data) => http({ url: '/manage/guestinto/getone', method: 'post', data })
  },
  exportFile: {
    p: 'post,/manage/guestinto/export',
    r: (data) => http({ url: '/manage/guestinto/export', method: 'post', data })
  }
};
